import styled from "styled-components";
import colors from "../../../config/colors";
import fonts from "../../../config/fonts";

export const InputContainer = styled.div``;

export const Label = styled.div`
  font-weight:bold;
  ${fonts.text};
  margin-bottom:10px;
`;
export const TheInput = styled.input`
  appearance: none;
  ${fonts.text};
  font-size: 16px;
  border-radius:5px;
  padding: 5px 10px;
  background-color: ${colors.background};
  border: solid 1px ${colors.darkPrimary};
  outline: none;
  transition: all 0.2s;
  width: ${(props) => (props.width ? props.width : "100%")};
  box-sizing:border-box;
  color:${colors.text};
  :hover {
    cursor: text;
    border: solid 1px ${colors.primary};
  }
  :focus {
    border-radius:10px;
    border: solid 1px ${colors.secondary};
  }
`;
